/* Animalsy – tarjeta de colección: pills de variante, cantidad, precio y badge.
   Se carga una sola vez (theme.liquid) y funciona por delegación, así que
   también sirve para tarjetas añadidas con scroll infinito, filtros o recomendaciones. */
(function () {
  if (window.anmCardReady) return;
  window.anmCardReady = true;

  function money(cents) {
    try {
      if (window.FoxTheme && FoxTheme.Currency && FoxTheme.settings && FoxTheme.settings.moneyFormat) {
        return FoxTheme.Currency.formatMoney(cents, FoxTheme.settings.moneyFormat);
      }
    } catch (e) {}
    return (cents / 100).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' });
  }

  function updatePrice(card, price, compare, available) {
    var el = card.querySelector('.f-price');
    if (!el) return;
    el.classList.remove('f-price--sold-out', 'f-price--on-sale', 'f-price--no-compare');
    if (!available) el.classList.add('f-price--sold-out');
    if (compare > price) el.classList.add('f-price--on-sale');
    el.querySelectorAll('.f-price__regular .f-price-item--regular').forEach(function (n) { n.innerHTML = money(price); });
    var sale = el.querySelector('.f-price__sale');
    if (sale) {
      var s = sale.querySelector('.f-price-item--sale');
      if (s) s.innerHTML = money(price);
      var r = sale.querySelector('.f-price-item--regular');
      if (r) r.innerHTML = '<s>' + money(compare) + '</s>';
    }
  }

  function updateBadge(card, buy, price, compare, available) {
    var wrap = card.querySelector('.product-card__image-wrapper');
    if (!wrap) return;
    var box = wrap.querySelector('.product-card__badge');
    var badge = box ? box.querySelector('.f-badge--sale') : null;
    var onSale = available && compare > price && buy.dataset.saleShow === 'true';
    if (!onSale) { if (badge) badge.style.display = 'none'; return; }
    var type = buy.dataset.saleType;
    var text = buy.dataset.saleText || '';
    if (type === 'show_percentage') {
      text = '-' + Math.floor((compare - price) * 100 / compare) + '%';
    } else if (type === 'show_amount') {
      text = (buy.dataset.saveText || '').replace('__AMT__', money(compare - price));
    }
    if (!box) {
      box = document.createElement('div');
      box.className = 'product-card__badge';
      var link = wrap.querySelector('a');
      if (link) link.insertAdjacentElement('afterend', box); else wrap.appendChild(box);
    }
    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'f-badge f-badge--sale';
      badge.setAttribute('aria-hidden', 'true');
      box.insertBefore(badge, box.firstChild);
    }
    badge.style.display = '';
    badge.innerHTML = text;
  }

  function selectPill(pill) {
    var form = pill.closest('form');
    if (!form) return;
    var card = pill.closest('.product-card') || form;
    var buy = form.querySelector('.anm-card-buy') || form;

    form.querySelectorAll('.anm-pill').forEach(function (p) {
      var on = p === pill;
      p.classList.toggle('is-active', on);
      p.setAttribute('aria-checked', on ? 'true' : 'false');
      p.tabIndex = on ? 0 : -1;
    });

    var id = pill.dataset.variantId;
    var input = form.querySelector('input[name="id"]');
    if (input) input.value = id;

    var price = parseInt(pill.dataset.price, 10) || 0;
    var compare = parseInt(pill.dataset.compareAtPrice, 10) || 0;
    var available = pill.dataset.available === 'true';

    updatePrice(card, price, compare, available);
    updateBadge(card, buy, price, compare, available);

    var btn = form.querySelector('.anm-atc');
    if (btn) {
      btn.disabled = !available;
      if (available) btn.removeAttribute('aria-disabled'); else btn.setAttribute('aria-disabled', 'true');
      var label = btn.querySelector('.anm-atc__text');
      if (label) label.textContent = available ? btn.dataset.labelAdd : btn.dataset.labelSoldout;
      btn.setAttribute('aria-label', available ? btn.dataset.labelAddLong : btn.dataset.labelSoldout);
    }

    if (pill.dataset.image) {
      var img = card.querySelector('.product-card__image--main img');
      if (img) { img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = pill.dataset.image; }
    }

    var base = buy.dataset.productUrl;
    if (base) {
      card.querySelectorAll('a[href]').forEach(function (a) {
        var href = a.getAttribute('href');
        if (href && href.split('?')[0] === base) a.setAttribute('href', base + '?variant=' + id);
      });
    }
  }

  document.addEventListener('click', function (e) {
    var pill = e.target.closest('.anm-pill');
    if (pill) { e.preventDefault(); selectPill(pill); return; }

    var b = e.target.closest('.anm-qty__btn');
    if (b) {
      e.preventDefault();
      var input = b.parentElement.querySelector('.anm-qty__input');
      var v = parseInt(input.value, 10) || 1;
      v += b.dataset.step === 'up' ? 1 : -1;
      input.value = Math.max(1, Math.min(999, v));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  document.addEventListener('change', function (e) {
    if (!e.target.matches || !e.target.matches('.anm-qty__input')) return;
    var v = parseInt(e.target.value, 10);
    e.target.value = isNaN(v) || v < 1 ? 1 : Math.min(v, 999);
  });

  document.addEventListener('keydown', function (e) {
    var pill = e.target.closest && e.target.closest('.anm-pill');
    if (!pill) return;
    var keys = ['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp'];
    if (keys.indexOf(e.key) === -1) return;
    var list = Array.prototype.slice.call(pill.parentElement.querySelectorAll('.anm-pill'));
    var i = list.indexOf(pill) + (e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : -1);
    if (i < 0) i = list.length - 1;
    if (i >= list.length) i = 0;
    e.preventDefault();
    list[i].focus();
    selectPill(list[i]);
  });
})();
